import React from 'react';
import { motion } from 'framer-motion';
import { MessageCircle } from 'lucide-react';
export const WA_URL = 'https://wa.me/573125895366?text=Hola,%20quiero%20mi%20asesor%C3%ADa%20pensional';
interface WhatsAppButtonProps {
  text?: string;
  className?: string;
  fullWidth?: boolean;
  size?: 'sm' | 'md' | 'lg';
}
export function WhatsAppButton({
  text = 'Contáctanos por WhatsApp',
  className = '',
  fullWidth = false,
  size = 'md'
}: WhatsAppButtonProps) {
  const sizeClasses = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg'
  };
  return <a href={WA_URL} target="_blank" rel="noopener noreferrer" className={`inline-flex items-center justify-center gap-2 bg-[#25D366] hover:bg-[#1EBE5D] text-white font-semibold rounded-lg transition-colors shadow-sm hover:shadow-md ${sizeClasses[size]} ${fullWidth ? 'w-full' : ''} ${className}`} data-id="element-165">
      <MessageCircle className={size === 'lg' ? 'w-6 h-6' : 'w-5 h-5'} data-id="element-166" />
      <span data-id="element-167">{text}</span>
    </a>;
}
interface SectionProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
  bg?: 'white' | 'slate' | 'dark';
}
export function Section({
  children,
  className = '',
  id,
  bg = 'white'
}: SectionProps) {
  const bgClasses = {
    white: 'bg-white',
    slate: 'bg-slate-50',
    dark: 'bg-slate-900 text-white'
  };
  return <section id={id} className={`py-16 md:py-24 ${bgClasses[bg]} ${className}`} data-id="element-168">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.5
    }} className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-169">
        {children}
      </motion.div>
    </section>;
}
export function FloatingWhatsApp() {
  return <motion.a initial={{
    scale: 0,
    opacity: 0
  }} animate={{
    scale: 1,
    opacity: 1
  }} transition={{
    delay: 1,
    type: 'spring',
    stiffness: 200,
    damping: 20
  }} href={WA_URL} target="_blank" rel="noopener noreferrer" className="fixed bottom-6 right-6 z-50 flex items-center justify-center w-14 h-14 bg-[#25D366] text-white rounded-full shadow-lg hover:bg-[#1EBE5D] hover:scale-105 transition-all focus:outline-none focus:ring-4 focus:ring-[#25D366]/50" aria-label="Contactar por WhatsApp" data-id="element-170">
      <MessageCircle className="w-8 h-8" data-id="element-171" />
    </motion.a>;
}